/** Brand signoff below all tabs. Reinforces product ownership — same
 * copy as the Streamlit version. */
export function Footer() {
  return (
    <footer className="mt-10 flex items-center justify-center gap-3 text-xs text-text-3">
      <span className="font-display font-bold tracking-[0.2em] text-text-2">
        ALTOSTRATUS
      </span>
      <span aria-hidden className="opacity-50">
        //
      </span>
      <span>Leaderboard de IA · Cloud Consulting</span>
    </footer>
  );
}
